import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/**
 * Bottom-of-transcript affordance (LAT-963): once the reader scrolls up, Claudia stops following
 * the stream, so there has to be a way back. It floats over the bottom edge of the scroll
 * viewport, which means its parent must be the positioned wrapper *around* `ScrollShadow` — not
 * the scrolling content, or it would scroll away with the transcript.
 */
export function AssistantTranscriptScrollToBottomButton({
  className,
  onClick,
}: {
  className?: string;
  onClick: () => void;
}) {
  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-3 z-10 flex justify-center">
      <Button
        aria-label="Scroll to the latest message"
        className={cn("pointer-events-auto bg-background shadow-sm", className)}
        data-testid="assistant-transcript-scroll-to-bottom"
        onClick={onClick}
        size="icon-sm"
        type="button"
        variant="outline"
      >
        <ArrowDown aria-hidden="true" />
      </Button>
    </div>
  );
}
